import React from 'react';
import { Line } from 'react-chartjs-2';
import { Col, Card, CardBody } from 'reactstrap';
import { LineChart2 } from '../../../Constant';
import { lineChart2Data, lineChart2option } from '../../../Data/Charts/ChartjsData';
import HeaderCard from '../../Common/HeaderCard';

const LineChart2Class = () => {
  return (
    <Col xl='6' md='12'>
      <Card>
        <HeaderCard title={LineChart2} />
        <CardBody className='chart-block'>
          <Line data={lineChart2Data} options={lineChart2option} width={734} height={377} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineChart2Class;
